import React from "react";
import { ERROR_LIGHT } from "@streeteasy/design-system/colors";
import { bool, string } from "prop-types";

import { AgentConfigurationLink } from "src/features/showing-time";

import HeaderNavButton from "../HeaderNavButton";
import { List, ListItem } from "../HeaderNavDropdownList";
import { useMainNavDropdown } from "../MainNav/hooks";
import { DEFAULT_DROPDOWN_TITLE } from "./constants";
import * as S from "./styled";

const AgentToolsDropdown = ({
  can_view_homepage_featured_listings_dashboard,
  cart_abandoned,
  homepage_featured_listings_slot_available,
  is_agent,
  is_expert_suspended,
  is_manager,
  tools_title_for_user
}) => {
  const {
    dropdownRef,
    isActive,
    onClick,
    onMouseEnter,
    onMouseLeave
  } = useMainNavDropdown();

  const AttentionMark = is_expert_suspended ? (
    <svg
      height={8}
      style={{ position: "relative", top: -6, left: -4 }}
      width={8}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={4} cy={4} fill={ERROR_LIGHT} r={4} />
    </svg>
  ) : null;
  const MyListingsLink = (
    <ListItem
      isAttention={cart_abandoned}
      link="/manage/listings"
      title="My Listings"
    />
  );
  const ListingsReportingLink = (
    <ListItem
      link="/manage/reporting/sale?site=nyc"
      title="Listing Reporting"
    />
  );
  const PastListingsLink = is_agent ? (
    <ListItem link="/manage/listings/past_listings" title="Past Listings" />
  ) : null;
  const AgentConfigurationLinkWrapper = is_agent ? (
    <ListItem isRaw title={<AgentConfigurationLink agent_dropdown />} />
  ) : null;
  const FloodlightListingsLink = can_view_homepage_featured_listings_dashboard ? (
    <ListItem
      isAttention={homepage_featured_listings_slot_available}
      link="/manage/floodlight_listings?site=nyc"
      title="Floodlight Listings"
    />
  ) : null;
  const AgentsLink = is_manager ? (
    <ListItem link="/manage/agents" title="Agents" />
  ) : null;
  const ComparablesLink = (
    <ListItem link="/my/comparables" title="Comparables" />
  );
  const FoldersLink = <ListItem link="/folders" title="Folders" />;
  const DataDashboardLink = is_agent ? (
    <ListItem
      link="https://streeteasy.com/blog/data-dashboard/"
      title="Data Dashboard"
    />
  ) : null;

  return (
    <>
      <HeaderNavButton
        aria-expanded={isActive}
        aria-haspopup="true"
        aria-label={tools_title_for_user}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {tools_title_for_user} &nbsp;
        <S.CaretIcon />
        {AttentionMark}
      </HeaderNavButton>
      <div ref={dropdownRef}>
        <S.StyledMenuPopup
          isActive={isActive}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          role="tooltip"
        >
          <>
            <List>
              {MyListingsLink}
              {ListingsReportingLink}
              {PastListingsLink}
              {AgentConfigurationLinkWrapper}
              {FloodlightListingsLink}
              {AgentsLink}
            </List>
            <List>
              {ComparablesLink}
              {FoldersLink}
              {DataDashboardLink}
            </List>
          </>
        </S.StyledMenuPopup>
      </div>
    </>
  );
};

AgentToolsDropdown.propTypes = {
  cart_abandoned: bool,
  is_expert_suspended: bool,
  can_view_homepage_featured_listings_dashboard: bool,
  homepage_featured_listings_slot_available: bool,
  tools_title_for_user: string,
  is_agent: bool,
  is_manager: bool
};

AgentToolsDropdown.defaultProps = {
  cart_abandoned: false,
  is_expert_suspended: false,
  can_view_homepage_featured_listings_dashboard: false,
  homepage_featured_listings_slot_available: false,
  tools_title_for_user: DEFAULT_DROPDOWN_TITLE,
  is_agent: false,
  is_manager: false
};

export default AgentToolsDropdown;
